<template>

<div> 
    <div class="smallKeywordBoard">

    <div v-on:click="showBooksonKeywords(chosenkeyword)" 
        v-for="chosenkeyword in defaultKeywords" v-bind:key="chosenkeyword.id"
        class="nKeywordBtn" v-bind:class="{'keywordBtnActive': chosenkeyword.isActive}">
        {{ chosenkeyword.keyword }}
    </div>         

    <div v-on:click="showBooksonKeywords(chosenkeyword)"
        v-for="chosenkeyword in recommendKeywords" v-bind:key="chosenkeyword.id" 
        class="nKeywordBtn" v-bind:class="{'keywordBtnActive': chosenkeyword.isActive}">       
        #{{ chosenkeyword.keyword }}
        </div>
    </div>

    
    
<!-- 하위 키워드 -->

   <!-- <div class="container"> <h2> 현재 키워드는 {{ currentkeywords }} </h2> </div> -->

</div>
  
</template>

<script>
export default {

    props: ['defaultKeywords','recommendKeywords', 'currentkeywords'],

    data: function() {

        return {

            clickedKeyword: ""

        }

    },

    
     methods: {

         showBooksonKeywords: function(keyword) {

            if(keyword.keyword == "전체보기") {

                this.$emit('btnAllbooks', this.keyword);
                console.log("btnAllbooks이 활성화 되었습니다.");

            }
            
            else if(keyword.keyword == "추천도서") {
                
                this.$emit('recommendBooks', this.keyword);
                console.log("recommendBooks이 활성화 되었습니다.");

            }

            else {            

                if(keyword.isActive == false) {
                           
                    console.log("클릭온");
    //              this.initBtnColor();          
                    this.$emit('clickKeyword', keyword);  
               }
            
                else { 

                    console.log("클릭오프");
                    this.$emit('cancleKeyword', keyword);                             
                     
                }
            }

         },


/*
        initBtnColor: function() {

            for(var i=0; i<this.recommendKeywords.length; i++) {

                this.recommendKeywords[i].isActive = false;
            }

            console.log("전체버튼이 활성화 되어서 모든 클릭이 꺼집니다.");

        }  
  */      
     }
   
}

</script>

<style scoped>

.smallKeywordBoard {

    display: flex;
    flex-wrap: wrap;
    justify-content: center;   
        
}

.sKeywordBtn {

  box-sizing: border-box;

}

.nKeywordBtn {
    
  cursor: pointer;
  background-color:#e1e1e1;
  
  box-sizing: border-box;
  
  height: 28px;
  margin: 2px;

  padding: 5px 6px 0px 6px;
  border-radius: 5px;

  text-align: center;

  border: grey;
  font-size: 12px;
  
}

.keywordBtnActive {

  box-sizing: border-box;

  cursor: pointer;
  background-color:#9fb1ee;

  
  height: 28px;
  margin: 2px;

  padding: 5px 6px 0px 6px;
  border-radius: 5px;

  text-align: center;

}

</style>